
<script>
    import HamburgerOptionsMixin from "../../../author/pagesbuilder/mixins/HamburgerOptionsMixin";
    import DimensionMixin from "../../../author/pagesbuilder/mixins/DimensionMixin";

    export default {
        name: "ImageElement",
        mixins: [HamburgerOptionsMixin, DimensionMixin],
        data() {
            return {
                elementType: 'image',
                analogDimensions: true
            }
        },
        methods: {
            elementCreationCallback () {
                this.checkIfTopbarDefaultLogo();
            },
            checkIfTopbarDefaultLogo () {
                if (this.inTopbar && !this.inMegamenu && !this.elementNode.src ) {
                    this.elementNode.src =  window.serverImg;
                    if (window.SCHOOL_LOGO.indexOf("/") === 0) {
                        this.elementNode.src += window.SCHOOL_LOGO.substr(1);
                    } else {
                        this.elementNode.src += window.SCHOOL_LOGO
                    }
                    this.setWidth({value:150});
                }
            }
        }
    }
</script>
